import {
   // Balout,
   Diriyah,
   // FormulaE,
   GSA,
   // GWB,
   JeddahSeason,
   // Misk,
   RiyadhMarathon,
   // SuperShowdown,
   SuperCopa,
   TakeshiCastle,
   WWE,
   FE,
   F1,
   FD,
   SaudiCup,
   Doos,
} from '~/svgs/business/events';

const GridCards = () => {
   return (
      <div className="p-8 lg:py-12 lg:px-24 rounded-3xl bg-white mb-6 shadow-sm">
         <div className="grid grid-cols-3 xl:grid-cols-6 gap-x-6 lg:gap-x-24 lg:gap-14 justify-items-center items-center">
            <SuperCopa className="p-7 lg:p-0" />
            <SaudiCup className="p-5 lg:p-0" />
            <F1 className="p-5 lg:p-0" />
            <FE className="p-5 lg:p-0" />
            <FD className="p-5 lg:p-0" />
            <JeddahSeason className="p-7 lg:p-0" />
            <Diriyah className="p-5 lg:p-0" />
            <WWE className="p-5 lg:p-0" />
            <GSA className="p-5 lg:p-0" />
            <RiyadhMarathon className="p-5 lg:p-0" />
            <TakeshiCastle className="p-5 lg:p-0" />
            <Doos className="p-5 lg:p-0" />
         </div>
      </div>
   );
};

export default GridCards;
